module.exports = __webpack_public_path__ + "img/tenant.f291fcb2.jpg";